import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const moduleStateManager = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    canvas: null,
    steps: null,
    currentStep: null,
    currentUgcView: 0,
    skipAlmostDone: false,
    isLoading: false,
    activeControl: "",
    isPopArtOrTileApplied: false
  }
};

export default moduleStateManager;
